import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { createDegree } from "../../../../graphql/mutations";
import SimpleCreateEdit from "../../../Common/Crud/SimpleCreateEdit";
import TextInput from "../../../../components/Common/TextInput";
import * as DegreesConstants from "../../../../graphql/Constants/Degrees/Types";
import nameChangeHandler from "../../../Common/Crud/formHandlers/nameChangeHandler";
import orderChangeHandler from "../../../Common/Crud/formHandlers/orderChangeHandler";
import nameOnlyFormsValidationHandler from "../../../Common/Crud/formHandlers/nameOnlyFormsValidationHandler";
import * as CrudActionTypes from "../../../../constants/Crud/ActionTypes";
import * as ModelTypes from "../../../../graphql/Constants/ModelTypes";

const DegreeCreate = (props) => {
  // states
  const [name, setName] = useState("");
  const [order, setOrder] = useState(0);
  const [inputFieldsDisable, setInputFieldsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [createButtonDisableStatus, setCreateButtonDisableStatus] = useState(
    false
  );

  const handleCreateDegree = async () => {
    try {
      const input = {
        type: ModelTypes.Degree,
        name: name.trim(),
        order: order,
        deletedAt: null,
      };
      await API.graphql(graphqlOperation(createDegree, { input }));
      return { result: true, message: `Degree created successfully` };
    } catch (error) {
      return { result: false, message: `Error creating degree, ${error}` };
    }
  };

  return (
    <SimpleCreateEdit
      {...props}
      crudActionType={CrudActionTypes.Create}
      returnHandler={() => props.history.push(`/degrees`)}
      modelName="Degree"
      updateDisableMethod={(modelData) => {
        if (modelData.id === DegreesConstants.Other.id) return true;
        return false;
      }}
      updateDisabledActions={() => {
        setInputFieldsDisable(true);
      }}
      formSubmissionHandler={handleCreateDegree}
      formValidationHandler={() =>
        nameOnlyFormsValidationHandler(
          name,
          "Degree",
          true, // we need to exclude the OTHER,
          setCreateButtonDisableStatus,
          setErrors
        )
      }
      setErrorsState={() => setErrors}
      actionButtonDisabledState={createButtonDisableStatus}
    >
      <TextInput
        type="text"
        id="name"
        label="Degree Name"
        placeholder="Enter a Degree name"
        value={name}
        onChange={(e) =>
          nameChangeHandler(
            e,
            "Degree",
            true, // we need to exclude the OTHER,
            setName,
            setCreateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.name}
        disabled={inputFieldsDisable}
      />
      <TextInput
        type="number"
        id="order"
        label="Degree Order"
        placeholder="Enter a Degree Order"
        value={order}
        onChange={(e) =>
          orderChangeHandler(
            e,
            "Degree",
            setOrder,
            setCreateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.order}
        disabled={inputFieldsDisable}
      />
    </SimpleCreateEdit>
  );
};

export default DegreeCreate;
